module.exports = __webpack_public_path__ + "img/tournaments_600.7f00aa4f.png";